import { Deserializable } from '../interfaces';

export class ShortCard implements Deserializable {
  descripcionCorta: string;
  habilitado: boolean;
  idFormaPagoC: number | null;
  Tarjeta: string;

  constructor() {
    this.descripcionCorta = '';
    this.habilitado = false;
    this.idFormaPagoC = null;
    this.Tarjeta = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
